import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
import PropTypes from 'prop-types';
import {CreateBulkCourierDetails } from "../../commonHandlerFunction/InvoiceHandlerFunctions";
import { decryptDataForURL } from "../../../../utills/useCryptoUtils";

const AddCourierDataButton = ({
    navigate,
    formData,
    setIsOverlayLoader,
    handleSubmit
}) => {
    const { t } = useTranslation();
    const translate = t;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const handleSaveButtonclick = () => {
        CreateBulkCourierDetails(formData, setIsOverlayLoader, navigate,handleSubmit)
    }
    return (
        <div className="submit_btns">
            <React.Fragment>
                <Button
                    type="button"
                    className="cancelBtn"
                    id="submit_btn3"
                    onClick={() => {
                        navigate("/operation/invoice-listing")
                    }}
                >
                    {translate("common.backBtn")}
                </Button>
                <Button
                    type="button"
                    className="submitBtn"
                    id="submit_btn1"
                    // disabled={checkValidation('post')}
                    onClick={(e) => {
                        handleSaveButtonclick()
                    }}
                >
                    Save
                </Button>
            </React.Fragment>

        </div >
    );
};


AddCourierDataButton.propTypes = {
    setIsPopupOpen: PropTypes.func,
    setJRFCreationType: PropTypes.func,
    handleBackButtonFunction: PropTypes.func,
    viewOnly: PropTypes.bool,
};

export default AddCourierDataButton;
